"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
class PrismicMigrationAsset {
  /**
   * Creates a migration asset used with the Prismic Migration API.
   *
   * @param config - Configuration of the asset.
   * @param initialField - The initial field value if any.
   *
   * @returns A migration asset instance.
   */
  constructor(config, initialField) {
    /**
     * Asset object from Prismic, available once created.
     */
    __publicField(this, "asset");
    /**
     * Configuration of the asset.
     */
    __publicField(this, "config");
    /**
     * The initial field value this migration field was created with.
     */
    __publicField(this, "originalField");
    this.config = config;
    this.originalField = initialField;
  }
}
exports.PrismicMigrationAsset = PrismicMigrationAsset;
//# sourceMappingURL=Asset.cjs.map
